import { mapState } from 'vuex'
import api from '../api/api'
import {mask} from 'vue-the-mask'

export default {
  directives: {
    mask
  },
  methods: {
    postcodeLookup() {
      this.$store.commit('customer/setErrors', {})
      if (this.customer.zip_code.trim()) {
        this.getAddressStatus = api.status.PENDING
        api.findAddress(this.customer.zip_code).then((response) => {
          this.addresses = response.data.addresses
          this.getAddressStatus = api.status.SUCCESS
        }).catch((error) => {
          this.addresses = []
          this.$store.commit('customer/setErrors', { zip_code: 'Postcode is invalid' })
          this.getAddressStatus = api.status.FAILURE
        })
      } else {
        this.$store.commit('customer/setErrors', { zip_code: 'Please enter a postcode' })
      }
    },
    formatAddress(address) {
      return address.formatted_address.filter(String).join(', ')
    }
  },
  computed: {
    ...mapState({
      errors: state => state.customer.errors
    })
  },
  watch: {
    selectedAddress() {
      const address = this.addresses[this.selectedAddress]
      this.customer.street_number = [address.building_number, address.building_name].filter(String).join(' ')
      this.customer.street = address.thoroughfare
      this.customer.city = address.town_or_city
    }
  },
  data() {
    return {
      getAddressStatus: null,
      countries: [],
      addresses: [],
      selectedAddress: null,
      titles: ['Mr', 'Mrs', 'Ms', 'Miss', 'Dr'],
      customer: {
        email: '',
        email_confirmation: '',
        title: '',
        first_name: '',
        last_name: '',
        street_number: '',
        street: '',
        city: '',
        zip_code: '',
        country: 'United Kingdom',
        phone_number: '',
        password: '',
        password_confirmation: '',
        allow_e_mails: this.$store.state.settings.tenant.allow_emails_default ? 'Yes' : 'No'
      },
      postcodeMask: {
        mask: 'PPPPPPPPP',
        tokens: {
          P: {
            pattern: /[0-9a-zA-Z ]/,
            transform: v => v.toLocaleUpperCase()
          }
        }
      }
    }
  },
  created() {
    api.getCountries().then((response) => {
      this.countries = response.data
    })
  },
}
